import { createReducer, on } from '@ngrx/store';
import { CategoryAirplaySecurityProfileApiActions } from './category-airplay-security-profile.actions';
import { adapter, initialState, selectId } from './category-airplay-security-profile.state';

export const categoryAirplaySecurityProfileReducer = createReducer(
  initialState,
  on(
    CategoryAirplaySecurityProfileApiActions.categoryProfileLoaded,
    CategoryAirplaySecurityProfileApiActions.categoryProfileAdded,
    (state, { configuration }) => {
      return adapter.upsertOne(configuration, state);
    }
  ),
  on(CategoryAirplaySecurityProfileApiActions.categoryProfileUpdated, (state, { configuration }) => {
    return adapter.updateOne(
      {
        id: selectId(configuration),
        changes: configuration,
      },
      state
    );
  }),
  on(CategoryAirplaySecurityProfileApiActions.categoryProfileDeleted, (state, { configuration }) => {
    return adapter.removeOne(selectId(configuration), state);
  })
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectCategoryAirplaySecurityProfileIds = selectIds;
export const selectCategoryAirplaySecurityProfileEntities = selectEntities;
export const selectAllCategoryAirplaySecurityProfiles = selectAll;
